module.exports = __webpack_public_path__ + "static/media/outerBackground.53a46e05.jpg";